/**
 * Generates a commit URL from a given remote repository URL and commit hash.
 *
 * This function supports GitHub URLs in both SSH and HTTPS formats.
 * If the remote URL is not a GitHub URL, it returns null.
 *
 * @param {string} remote_url - The remote repository URL.
 * @param {string} commit - The commit hash.
 * @returns {string | null} - The generated commit URL or null if the URL is invalid.
 */
export const getCommitUrlFromRemoteUrl = (
  remote_url: string,
  commit: string
): string | null => {
  try {
    if (!remote_url.includes('github')) {
      return null;
    }
    if (remote_url.includes('git@')) {
      return remote_url
        .replace(':', '/')
        .replace('git@', 'https://')
        .replace('.git', `/commit/${commit}`);
    } else if (remote_url.includes('https://')) {
      if (remote_url.includes('.git')) {
        return remote_url.replace('.git', `/commit/${commit}`);
      }
      return `${remote_url}/commit/${commit}`;
    }
  } catch {
    // pass
  }

  return null;
};
